import React from "react";

function Footer() {
  return (
    <div>
      <footer className="footerMain">
        <div className="d-flex justify-content-center py-2 text-light">
            &copy; {2021} noon. All Right Reserved
        </div>
      </footer>
    </div>
  );
}

export default Footer;
